import { gql } from "@apollo/client";

export const SEARCH_USER_TASKS_QUERY = gql`
  query searchUserTasks(
    $appId: ID
    $organizationId: ID
    $limit: Int
    $offset: Int
    $query: String
    $sortOrder: [String!]
    $statuses: [UserTaskStatus!]
    $assignedUserId: ID
    $assignedUserGroupId: ID
    $archived: Boolean
    $patientId: ID
    $tags: [String!]
    $userTags: [String!]
    $systemTags: [String!]
  ) {
    searchUserTasks(
      appId: $appId
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      query: $query
      sortOrder: $sortOrder
      statuses: $statuses
      assignedUserId: $assignedUserId
      assignedUserGroupId: $assignedUserGroupId
      archived: $archived
      patientId: $patientId
      tags: $tags
      userTags: $userTags
      systemTags: $systemTags
    ) {
      total
      items {
        id
        title
        status
        dueDateTime
        updatedAt
        notes
        patient {
          id
          firstName
          lastName
        }
        __typename
      }
    }
  }
`;

export const GET_USER_TASK = gql`
  query getUserTask($id: ID!) {
    getUserTask(id: $id) {
      id
      organizationId
      title
      status
      wontCompleteReason
      description
      detailedInstructions
      notes
      # form
      dueDateTime
      createdAt
      tags
      userTags
      customFields
      customFormServiceInstanceId
      patient {
        id
        firstName
        lastName
      }
      assignedUsers {
        id
        email
        fullName
      }
      assignedUserGroups {
        id
        name
      }
      attachments {
        id
        title
        description
        url
        contentType
        documentName
      }
    }
  }
`;

export const SEARCH_MEMBERS = gql`
  query searchMembersForWidget(
    $organizationId: ID!
    $query: String!
    $limit: Int
    $offset: Int
    $sortOrder: [String!]
  ) {
    searchMembersForWidget(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      query: $query
      sortOrder: $sortOrder
    ) {
      total
      items {
        id
        userId
        organizationId
        createdAt
        updatedAt
        inviteSentAt
        active
        user {
          id
          fullName
          email
          lastActive
          lastLogin
          photo
        }
        roles {
          items {
            id
            name
          }
        }
      }
    }
  }
`;

export const SEARCH_MEMBERS_VARS = {
  organizationId: null,
  limit: 10,
  offset: 0,
  query: "",
  sortOrder: ["fullName.keyword_norm"],
};

export const GET_ORGANIZATION_SETTINGS = gql`
  query getOrganizationSettings(
    $organizationId: ID!
    $settingsInput: [GetOrganizationSettingInput!]!
  ) {
    getOrganizationSettings(
      organizationId: $organizationId
      settingsInput: $settingsInput
    ) {
      key
      value
    }
  }
`;

export const SEARCH_USER_GROUPS_GQL = gql`
  query searchUserGroups(
    $organizationId: ID!
    $query: String!
    $limit: Int
    $offset: Int
  ) {
    searchUserGroups(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      query: $query
    ) {
      total
      items {
        id
        name
        description
        users(limit: 100) {
          items {
            id
            fullName
            email
            lastLogin
            photo
          }
        }
        roles {
          items {
            id
            name
          }
        }
      }
    }
  }
`;

export const SEARCH_MEMBERS_GQL = gql`
  query searchMembers(
    $organizationId: ID
    $query: String!
    $limit: Int
    $offset: Int
    $sortOrder: [String!]
  ) {
    searchMembers(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      query: $query
      sortOrder: $sortOrder
    ) {
      total
      items {
        id
        userId
        organizationId
        createdAt
        updatedAt
        inviteSentAt
        active
        lastActiveAt
        fullName
        workEmail
        user {
          id
          fullName
          email
          lastLogin
          photo
        }
        roles {
          items {
            id
            name
          }
        }
      }
    }
  }
`;
